<template>
  <v-dialog
    v-model="dialog"
    scrollable
    max-width="768px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        text
        rounded
        small
        v-bind="attrs"
        v-on="on"
      >
        <v-icon left>mdi-send</v-icon>
        Send Requests
      </v-btn>
    </template>
    <v-card>
      <v-card-title>Send Acknowledgement Requests</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-row class="d-flex align-center">
          <v-col cols="12">
            <v-alert type="warning" dismissible>
              You are about to send emails to 
              {{this.employeesToSend.length}} recipients requesting them
              to complete their acknowledgement of this session.
            </v-alert>
          </v-col>
          <transition name="slide-fade-down-and-back">
            <v-col 
              v-if="employeesToRemove.length > 0" 
              class="d-flex justify-end"
            >
              <v-btn rounded class="error" @click="removeEmployees">
                Exclude {{ employeesToRemove.length }} employees
              </v-btn>
            </v-col>
          </transition>
        </v-row>
        <v-row>
          <v-col>
            <v-list shaped dense avatar>
              <v-list-item-group
                v-model="employeesToRemove"
                multiple
              >
                <template v-for="employee in employeesToSend">
                  <v-list-item
                    :key="employee.id"
                    :value="employee"
                    active-class="error--text text--accent-4"
                  >
                    <template v-slot:default="{ active, toggle }">
                      <v-list-item-avatar>
                        <v-img :src="getAvatar(employee)"></v-img>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title v-text="employee.fields.Name">
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          {{ employee.fields.Title }} &bullet; 
                          {{ employee.fields.Department}}
                        </v-list-item-subtitle>
                      </v-list-item-content>

                      <v-list-item-action>
                        <v-checkbox
                          :input-value="active"
                          :true-value="employee"
                          color="error accent-4"
                          @click="toggle"
                        ></v-checkbox>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </template>
              </v-list-item-group>
            </v-list>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn
          text
          rounded
          @click="reset"
        >
          <v-icon left>mdi-refresh</v-icon>
          Reset
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          text
          rounded
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          v-if="employeesToRemove.length > 0" 
          text
          rounded
          color="error" 
          @click="removeEmployees"
        >
          Exclude {{ employeesToRemove.length }} employees
        </v-btn>
        <v-btn
          v-else
          :loading="btnLoading"
          rounded
          color="primary"
          text
          @click="sendRequests"
        >
          <v-icon left>mdi-send</v-icon>
          Send to {{ this.employeesToSend.length }} employees
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'sendAcknowledgementRequests',
    props: {
      acknowledgements: Array, // these are really just employees
      session: Object
    },
    data () {
      return {
        dialog: false,
        btnLoading: false,
        employeesToRemove: [],
        removedEmployees: []
      }
    },
    computed: {
      employees () {
        return this.acknowledgements // this component has no acks, just emps
      },
      employeesToSend () {
        return this.employees.filter(e => {
          return !this.removedEmployees.includes(e.id)
        })
      }
    },
    methods: {
      getAvatar (employee) {
        if (employee.fields['Avatar']) {
          return employee.fields['Avatar'][0].url
        } else {
          const color = this.$vuetify.theme.themes.light.primary.split('#')[1]
          return `https://ui-avatars.com/api/?name=${employee.fields.Name}&background=${color}&color=fff&rounded=true`
        }
      },
      removeEmployees () {
        const removeIds = this.employeesToRemove.map(e => e.id)
        const alreadyRemovedIds = this.removedEmployees
        const totalToRemove = alreadyRemovedIds.concat(removeIds)
        const uniqueRemoveIds = new Set(totalToRemove)
        return this.removedEmployees = Array.from(uniqueRemoveIds)
      },
      reset () {
        this.employeesToRemove = []
        this.removedEmployees = []
      },
      sendRequests () {
        this.btnLoading = true
        const records = this.employeesToSend.map(e => {
          return {
            fields: {
              'Session': [this.session.id],
              'Employee': [e.id]
            }
          }
        })
        this.$store.dispatch('createRecords', {
          table: 'Acknowledgements',
          records: records
        })
        .then(() => {
          const emails = this.employeesToSend.map(e => {
            return e.fields.Email
          })
          // TODO: EMAILS SHOULD BE CHUNKED TO AVOID SENDING TOO MANY AT ONCE
          this.$store.dispatch('sendEmail', {
            to: '',
            bcc: emails.toString(),
            subject: `Requesting Your Acknowledgement for 
                      ${this.session.fields.Name}`,
            body: `Please follow <a href="${window.location.origin}/profile">
                  this link</a> to acknowledge that you attended and understood 
                  the materials presented in ${this.session.fields.Name}.`
          })
          this.$store.dispatch('getRecords', {
            table: 'Acknowledgements',
            view: 'All Acknowledgements',
            dispatch: 'setAcknowledgements'
          })
          this.$store.dispatch('setSnackbar', {
            snackbarColor: 'success',
            showSnackbar: true,
            snackbarY: 'top',
            snackbarX: 'right',
            snackbarText: `Acknowledgements requested!`
          })
          this.btnLoading = false
          this.dialog = false
          this.reset()
        })
      }
    }
  }
</script>
